import { createContext } from 'react';
import { IContentsModule } from 'types';

type TargetContextType = {
  target: IContentsModule | null;
  targetList: IContentsModule[];
  setTargetList: (
    data: IContentsModule[] | ((prev: IContentsModule[]) => IContentsModule[]),
  ) => void;
  setTarget: (data: IContentsModule) => void;
};

const TargetContext = createContext<TargetContextType>({
  target: null,
  targetList: [],
  setTarget: () => false,
  setTargetList: () => false,
});

export { TargetContext };
export type { TargetContextType };
